import { useLocalStorage } from '@mantine/hooks';

export const useHideOutcomes = () => {
  return useLocalStorage<boolean>({
    key: 'nba-insights-hide-outcomes',
    defaultValue: false,
  });
};
